import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import { Visibility, Edit } from '@material-ui/icons';
import { Checkbox, Grid, IconButton,  } from '@material-ui/core';
import { Note } from '@material-ui/icons';
import { Form, Select as SelectAntd, Input } from 'antd';
import InvisibleContent from '@components/Shared/InvisibleContent';

import ButtonWithIcon from '@components/Shared/Buttons/ButtonWithIcon';
import Button from '@components/Shared/Buttons/Button';
import TableCustomKeysNoPagination from '@components/Shared/Tables/TableCustomKeysNoPagination';

import { TitlePage } from '@src/@styles/styles.global';
import { useAuth } from '@hooks/AuthenticateContext';
import { FormatDate } from '@utils/formats';
import Modal from '@src/components/Shared/Modal/ModalPure';
import RecusarLote from '@src/Pages/Private/Cliente/Admin/InsercaoDoacoes/Modais/RecusarLote';
import RecusarDoacao from '@src/Pages/Private/Cliente/Admin/InsercaoDoacoes/Modais/RecusarDoacao';

import ButtonComponent from '@components/Shared/Buttons/Button';
import { PictureAsPdf } from '@material-ui/icons';

import Services, {
  IDoacoes,
  IDoacoesResultTable,
} from './services';


const columnsLabel = {
  dataCadastro: 'Data cadastro',
  idDoacao: 'Id doação',
  IDCadastro: 'ID cadastro',
  NomeCadastro: 'Nome',
  SolicitadoPor: 'Usuário responsável',
  Valor: 'Valor',
  origemDoacaoDescricao: 'Origem doação',
};



interface IProps {
  idPerfil: number;
  functionReload?: Function;
  idSolicitacao: number;
}

const ListLotesPendentes: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IDoacoes[]>([]);

  const { user, signOut } = useAuth();

  const [dadosSelecionadas, setDadosSelecionadas] = useState<string[]>([]);
  const [lotes, setLotes] = useState<any[]>([]);
  const [loteSelecionado, setLoteSelecionado] = useState<string | null>(null);
  const [reabrir, setReabrir] = useState(false);
  const [openModalRecuseLote, setOpenModalRecuseLote] = useState(false);
  const [openModalRecuseDoacao, setOpenModalRecuseDoacao] = useState(false);


  const carregarLotes = async () => {
    setLoading(true);
    let status = 2;
    const response = await Services.GetLotesFechados(status);
    if (!response.error) {
      setLotes(response.data);
    } else {
     // enqueueSnackbar('Erro ao carregar lotes', { variant: 'error' });
    }
    setLoading(false);
    //setReabrir(false);
  };


  const selectedDatas = (value: IDoacoesResultTable) => {
    if (dadosSelecionadas.filter(x => x === value.idDoacao).length <= 0) {
      setDadosSelecionadas([...dadosSelecionadas, value.idDoacao]);
    } else {
      const newArray = dadosSelecionadas.filter(function (item) {
        return item !== value.idDoacao;
      });
      setDadosSelecionadas(newArray);
    }
  };

  useEffect(() => {

    carregarLotes();
  }, [enqueueSnackbar]);

  useEffect(() => {
    const carregarDoacoesPorLote = async () => {
      if (!loteSelecionado) {
        setData([]);
        return;
      }
      setLoading(true);
      const response = await Services.GetDoacoesPorLote(Number(loteSelecionado));
      if (!response.error && response.data) {
        setData(response.data);
      } else {
        setData([]);
        enqueueSnackbar('Erro ao carregar doações do lote', { variant: 'error' });
      }
      setLoading(false);
      setReabrir(false);
    };
    carregarDoacoesPorLote();
  }, [loteSelecionado, enqueueSnackbar]);


  const quantidadeItens = ( data.length - dadosSelecionadas.length )

  const finishRecuseSolicitacao = async () => {
    formRef.resetFields();
      await setData([]);
      await carregarLotes();
      await setLoteSelecionado(null);

      setOpenModalRecuseLote(false);
      setOpenModalRecuseDoacao(false);  };


  useEffect(() => {
    window.document.title = 'CRM - Listagem lotes';
  }, []);


   {/*/Bloqueio inspecionar
   useEffect(() => {
  if (user.role !== 'ADM SOCIALLIS') {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'F12') {
        event.preventDefault();
        alert('F12 está desativado.');
      }
      if (event.ctrlKey && event.shiftKey && event.key === 'I') {
        event.preventDefault();
        alert('Ctrl+Shift+I está desativado.');
      }
      if (event.ctrlKey && event.shiftKey && event.key === 'J') {
        event.preventDefault();
        alert('Ctrl+Shift+J está desativado.');
      }
      if (event.ctrlKey && event.key === 'U') {
        event.preventDefault();
        alert('Ctrl+U está desativado.');
      }
    };

    const detectDevTools = () => {
      const threshold = 160;
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold = window.outerHeight - window.innerHeight > threshold;

      if (widthThreshold || heightThreshold) {
        alert('Ferramentas de desenvolvedor detectadas.');
        window.location.href = '/';
      }
    };

    const interval = setInterval(detectDevTools, 1000);

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      clearInterval(interval);
    };
  }
}, [user.role]);*/}


  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <TitlePage style={{ margin: 5 }}>Lotes pendentes</TitlePage>
      </Grid>

      <Grid item md={2} xs={4} style={{ margin: 5 }}>
            <ButtonComponent
              color="secondary"
              fullWidth
              disabled={!loteSelecionado}
              style={{ height: 37, width: 150 }}
              onClick={async () => {
                if (!loteSelecionado) return;

                const {error, response} = await Services.gerarRelatorio(Number(loteSelecionado));

                if (!error && response instanceof Blob) {
                  const fileURL = URL.createObjectURL(response);
                  const link = document.createElement('a');
                  link.href = fileURL;

                  const contentDisposition = response.type;
                  const fileName = `Relatorio_Lote_${loteSelecionado}.pdf`;

                  link.setAttribute('download', fileName);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);

                  URL.revokeObjectURL(fileURL);

                  enqueueSnackbar('Recibo baixado com sucesso', {
                    variant: 'success',
                    anchorOrigin: { horizontal: 'right', vertical: 'bottom' },

                  });
                  //await setLoteSelecionado(null);
                 //await setBotaoFechar(false);
                } else {
                  enqueueSnackbar('Erro ao gerar recibo', {
                    variant: 'error',
                    anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                  });
                }
              }



            }

            >
              <PictureAsPdf style={{ marginRight: 10 }} /> Gerar relatório
            </ButtonComponent>
          </Grid>


      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >
        <Grid item md={3} xs={4} style={{ margin: 5 }} >
          <Form.Item>
            <SelectAntd
              style={{ width: '80%' }}
              placeholder="Selecione um lote"
              loading={loading}
              value={loteSelecionado ?? undefined}
              onChange={value => setLoteSelecionado(value)}
            >
              {lotes.map((lote: any) => (
                <SelectAntd.Option key={lote.id} value={lote.id}>
                  {lote.id + " - " + lote.descricao}
                </SelectAntd.Option>
              ))}
            </SelectAntd>
          </Form.Item>
        </Grid>


      </Grid>

     <Grid item lg={12} xs={12}>
        <TableCustomKeysNoPagination

          loading={loading}
          columns={[columnsLabel]}
          FieldsBold={['NomeCadastro', 'SolicitadoPor']}
          data={data?.map((d: any) => ({
            dataCadastro: FormatDate(d.dataCadastro),
            IDCadastro: d.doadorId,
            NomeCadastro: d.doadorNome,
            SolicitadoPor: d.usuarioCadastroNome,
            Valor: d.valorDoacao.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
            origemDoacaoDescricao: d.origemDoacaoDescricao,
            idDoacao: d.idDoacao,
          })) ?? []}
          keys={[
            'dataCadastro',
            'IDCadastro',
            'NomeCadastro',
            'SolicitadoPor',
            'Valor',
            'origemDoacaoDescricao',
          ]}
        />
      </Grid>




    </Grid>
  );
};

export default ListLotesPendentes;
